import type { Operation } from '@apollo/client/link/core/types';
import type { RetryLink } from '@apollo/client/link/retry';

export const INITIAL_DELAY = 500;
export const MAX_DELAY_BETWEEN_RETRIES = 3200;

export const NUM_OF_ATTEMPTS = 5;

export function retryIf(error: unknown, operation: Operation) {
  switch (operation.operationName) {
    case 'HeartbeatQuery':
      return true;
    default:
      return false;
  }
}

const retryLinkConfig: RetryLink.Options = {
  delay: {
    initial: INITIAL_DELAY,
    max: MAX_DELAY_BETWEEN_RETRIES,
    jitter: false,
  },
  attempts: {
    max: NUM_OF_ATTEMPTS,
    retryIf,
  },
};

export default retryLinkConfig;
